import myFace from '../assets/simon.png'

export const demoProfileData = {
    id: 28256637,
    profile: myFace
}

export const demoUserActivitiesData = {
    runTotal: {
        kms: '9473.53',
        miles: '5886.58',
        count: 816
    },
    rideTotal: {
        kms: '6950.36',
        miles: '4318.75',
        count: 278
    },
    swimTotal: {
        kms: '1.57',
        miles: '0.98',
        count: 2
    }
}
